import { render, staticRenderFns } from "./imageuploaderSection.vue?vue&type=template&id=1d636032&scoped=true"
import script from "./imageuploaderSection.vue?vue&type=script&lang=js"
export * from "./imageuploaderSection.vue?vue&type=script&lang=js"
import style0 from "./imageuploaderSection.vue?vue&type=style&index=0&id=1d636032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d636032",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
